import { IAppState } from 'shared/common/state';

export const selectSuggestions = (state: IAppState) => state.results.suggestions || [];
